export const firebaseConfig = {
  apiKey: 'AIzaSyD91m04hL94f2gWGjZSWvnD5mMRvUo7vLQ',
  authDomain: 'rakudakko-377bc.firebaseapp.com',
  databaseURL: 'https://rakudakko-377bc.firebaseio.com',
  projectId: 'rakudakko-377bc',
  storageBucket: 'rakudakko-377bc.appspot.com',
  messagingSenderId: '103290346430',
}
